/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type RelayProjectVersionsType from '@jira/spa-apps__project-relay-versions/src/ExportedDefault.tsx';
import type { Props } from '@jira/spa-apps__project-relay-versions/src/ExportedDefault.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyRelayProjectVersions: LazyComponent<{
	(props: Props): React.JSX.Element;
	displayName: string;
}> = lazyForPaint<typeof RelayProjectVersionsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-relay-project-versions", jiraSpaEntry: "async-relay-project-versions" */ '@jira/spa-apps__project-relay-versions/src/ExportedDefault.tsx'
		),
	),
);

export const RelayVersions = (): React.JSX.Element => (
	<LazyPage
		Page={LazyRelayProjectVersions}
		pageId="relay-project-versions"
		shouldShowSpinner={false}
	/>
);
